import {
  ArticleBreadcrumbs,
  ArticleHeader,
  RelatedTags,
  ShareArticle,
} from "components/article-components"
import {
  LeaderboardTop,
  BillboardTop,
  NodigAds,
  Skyscraper,
} from "components/adbutler-advertisements"
import { Link, graphql } from "gatsby"
import {
  SEOComponent,
  createBfzArticleSchemaOrgData,
} from "components/seo-components"

import { AdvertorialTwo } from "components/native-advertisements"
import { ArticleTeaserCardNewest } from "components/page-components/Teaser-Cards"
import { Helmet } from "react-helmet"
import { LatestBfzEvents } from "components/page-components/Baufachzeitschriften/Termine"
import Layout from "components/structure-components/layout"
import { NewsletterSignup } from "components/page-components/Signup-Forms"
import React from "react"
import createStandardGermanDateWithTime from "scripts/createStandardGermanDateWithTime"
import generateSchemaOrgFaq from "scripts/generateSchemaOrgFaq"
import generateBfzArticleFaqData from "scripts/generateBfzArticleFaqData"
import generateSeededRandomPid from "scripts/generateSeededRandomPid"

import { getContentComponent } from "components/article-components/utils"
import { Gallery } from "components/article-components/content-components"
import { getSrc } from "gatsby-plugin-image"
import { NoticeWizard } from "components/page-components/Ausschreibungsdienste/notice-wizard"

import {
  ConstructionMethodsHorizontal,
  MostReadArticlesHorizontal,
  RelatedArticlesHorizontal,
  ArticleJobPosting,
} from "components/article-components/link-modules"

const magazineArticle = ({ location, data }) => {
  const {
    advertorialOneData,
    advertorialThreeData,
    advertorialTwoData,
    all_active_placements,
    articleData,
    defaultImage,
    mostReadArticles,
    newestTopicArticles,
    topFiveTags,
    umweltbauDates,
  } = data

  const {
    advertorial,
    article_body,
    article_content,
    article_id,
    article_images,
    article_images_zoomable,
    article_title_image,
    article_date,
    authors,
    construction_method_blogposts,
    gallery_images,
    gt_id,
    headline,
    is_comment,
    is_exclusive,
    is_sensitive,
    kicker,
    last_update,
    located,
    meta_description,
    noindex,
    ressort,
    related_articles,
    seo_title,
    slugline,
    thumbnail_large,
    topic,
    tags,
    teaser,
    topic_data,
    place_newsletter_organically,
    self_ads_placed,
    top_booking,
    job_posting,
  } = articleData

  const article_faq = generateBfzArticleFaqData(article_content)
  const schema_org_faq = generateSchemaOrgFaq(article_faq)

  let { horizontal_ad_sequence, vertical_ad_sequence } = articleData

  const self_ad_content = {
    most_read_articles: mostReadArticles?.nodes,
    related_articles: related_articles,
    construction_methods: construction_method_blogposts,
  }

  const { billboard_top, interscroller, leaderboard_top, skyscraper_right } =
    all_active_placements

  // this needs to be done to individually modify each articles unique placements.
  // numbers need to be increased for adbutler placement numbers
  // to ensure unique delivery and correct page rotation

  horizontal_ad_sequence = horizontal_ad_sequence.map((itm, index) => {
    if (itm !== "self") {
      return itm
    }
    const left_over_ad_type =
      index & 1 ? "leaderboard_content" : "billboard_content"
    all_active_placements[left_over_ad_type] += 1

    return left_over_ad_type
  })

  vertical_ad_sequence = vertical_ad_sequence.map((itm) => {
    if (itm !== "self") {
      return itm
    }
    all_active_placements.rectangle += 1
    return "rectangle"
  })

  const last_horizontal_ad_placed =
    !place_newsletter_organically && !!horizontal_ad_sequence?.[0]
      ? horizontal_ad_sequence.findLastIndex((hor_ad) =>
          [
            "billboard_content",
            "leaderboard_content",
            "outstream_video",
          ].includes(hor_ad)
        )
      : null

  const advertorialTwo =
    advertorialTwoData?.nodes[0] || advertorialOneData?.nodes[0] || null

  let all_images = {}
  article_images?.map((image) => {
    Object.assign(all_images, { [image.fields.imageNumber]: { ...image } })
    return image
  })

  let all_zoomable_images = {}
  article_images_zoomable?.map((image) => {
    Object.assign(all_zoomable_images, {
      [image.fields.imageNumber]: { ...image },
    })
    return image
  })

  const all_image_types = ["image", "image_zoomable", "image_title"]

  let paragraph_counter = 0

  const adbutler_places = {
    leaderboard_content: 0,
    billboard_content: 0,
    rectangle: 0,
    halfpage_content: 0,
    outstream_video: 0,
  }

  let horizontal_ticker = 0
  let vertical_ticker = 0

  const adbutler_page_id = generateSeededRandomPid(gt_id)

  const revised_article_content = article_content.flatMap((item, index) => {
    let revised_article_item = []
    item = {
      ...item,
      react_key: `article_item-${index}`,
      advertisement: "",
      ressort,
      adbutler_page_id,
      tags,
      topic,
    }

    if (
      item.type === "paragraph" &&
      paragraph_counter === 0 &&
      !is_sensitive &&
      !advertorial.is_advertorial
    ) {
      if (!!interscroller) {
        item.has_mobile_interscroller = true
      }
      if (
        !advertorial.is_advertorial &&
        !is_sensitive &&
        !!advertorialThreeData?.nodes?.[0]
      ) {
        revised_article_item.push({
          type: "advertorial_3",
          react_key: `advertorial_3-${index}`,
          advertorialThreeData: advertorialThreeData?.nodes?.[0],
        })
      }
      paragraph_counter++
    }

    if (all_image_types.includes(item.type)) {
      item = {
        ...item,
        type: !item.image_number ? "image_title" : item.type,
        seo_title: !item.image_number ? seo_title : null,
        image: !item.image_number
          ? article_title_image
          : all_images[item.image_number] || defaultImage,
        zoom_image: all_zoomable_images[item.image_number] || defaultImage,
      }
    }

    if (item.has_vertical_ad_slot) {
      const ad_type = vertical_ad_sequence[vertical_ticker]
      item.advertisement = ad_type
      item.self_ad_content = self_ad_content[ad_type]
      item.adbutler_place =
        adbutler_places[ad_type] % all_active_placements[ad_type]
      Object.assign(adbutler_places, {
        ...adbutler_places,
        [ad_type]: adbutler_places[ad_type] + 1,
      })
      vertical_ticker++
    }

    revised_article_item.push(item)

    if (item.has_horizontal_ad_slot) {
      const ad_type = horizontal_ad_sequence[horizontal_ticker]
      revised_article_item.push({
        type: ad_type,
        react_key: `${ad_type}-${index}`,
        adbutler_page_id,
        adbutler_place:
          adbutler_places[ad_type] % all_active_placements[ad_type],
        construction_method_blogposts: self_ad_content[ad_type],
        most_read_articles: self_ad_content[ad_type],
        related_articles: self_ad_content[ad_type],
        ressort,
        tags,
        topic,
      })
      if (
        horizontal_ticker === last_horizontal_ad_placed &&
        !place_newsletter_organically
      ) {
        revised_article_item.push({
          type: "newsletter_signup",
          react_key: `newsletter_signup-${index}`,
          ressort,
          adbutler_page_id,
        })
      }
      Object.assign(adbutler_places, {
        ...adbutler_places,
        [ad_type]: adbutler_places[ad_type] + 1,
      })
      horizontal_ticker++
    }

    return revised_article_item
  })

  const human_authors = [
    ...authors?.filter(({ type, name }) => type === "Person" && !!name),
  ].sort((a, b) => !!b.strapi_data - !!a.strapi_data)
  let organization_authors = authors?.filter(
    ({ type, name }) => type === "Organization" && !!name
  )

  if (!!advertorial.is_advertorial) {
    organization_authors = [
      ...(organization_authors || []),
      ...(human_authors || []),
    ].map(({ name }) => ({ name: name, type: "Organization" }))
    human_authors.length = 0
  }

  const schema_org_image_array = thumbnail_large
    ? Object.entries(thumbnail_large.childImageSharp)?.map(
        ([_, image]) => `https://bi-medien.de${getSrc(image)}`
      )
    : []

  const related_article_links = related_articles?.map(
    (rel_article) =>
      `https://bi-medien.de/fachzeitschriften/${rel_article?.ressort}/${rel_article?.topic_data.slug}/${rel_article?.slugline}-${rel_article?.gt_id}`
  )

  const breadcrumb_array = [
    {
      type: "BreadcrumbLink",
      content: `B_I ${ressort}`,
      link: `/fachzeitschriften/${ressort}`,
      react_key: "breadcrumb_item_1",
      ressort: ressort,
    },
    {
      type: "BreadcrumbLink",
      content: topic_data.short_title,
      link: `/fachzeitschriften/${ressort}/${topic_data.slug}`,
      react_key: "breadcrumb_item_2",
      scroll_here: true,
      ressort: ressort,
    },
    {
      type: "BreadcrumbHeading",
      content: seo_title,
      react_key: "breadcrumb_item_3",
    },
  ]
  const article_body_structured_data = `${kicker} ${seo_title} ${teaser} ${article_body}`

  const open_graph_image = {
    url: `https://bi-medien.de${getSrc(
      thumbnail_large?.childImageSharp?.sd_16x9
    )}`,
    width: thumbnail_large?.childImageSharp?.sd_16x9?.width,
    height: thumbnail_large?.childImageSharp?.sd_16x9?.height,
    alt: headline,
  }

  const display_date = createStandardGermanDateWithTime(article_date)

  const last_update_display = last_update
    ? createStandardGermanDateWithTime(last_update)
    : undefined

  const schema_org_data = createBfzArticleSchemaOrgData({
    article_body: article_body_structured_data,
    breadcrumb_array,
    article_date,
    seo_title,
    human_authors,
    last_update,
    location,
    meta_description,
    organization_authors,
    related_article_links,
    schema_org_image_array,
  })

  const content_tags = [
    ...(tags?.map(({ short_title }) => short_title) || []),
    ...(construction_method_blogposts?.map(({ title }) => title) || []),
    topic_data.short_title,
  ]

  const robots_meta_tags = Object.entries({
    nofollow: advertorial.is_advertorial !== 0,
    noindex: noindex,
  })
    .flatMap(([tag, bool]) => (!!bool ? tag : []))
    ?.join(", ")

  return (
    <Layout location={location}>
      <Helmet>
        {!!robots_meta_tags ? (
          <meta name="robots" content={robots_meta_tags} />
        ) : null}
        <meta name="x-bi-article-type" content="bfz" />
        <meta name="x-bi-article-id" content={article_id} />
        <meta name="x-bi-content-tags" content={JSON.stringify(content_tags)} />
      </Helmet>

      <SEOComponent
        no_brand
        title={seo_title}
        description={meta_description + " ► bei B_I MEDIEN lesen!"}
        schema_org_data={schema_org_data}
        open_graph_image={open_graph_image}
        schema_org_faq={schema_org_faq}
        open_graph_type="article"
      />

      <div className="is-hidden-mobile">
        {!advertorial.is_advertorial &&
        !is_sensitive &&
        (!!leaderboard_top || !!billboard_top) ? (
          !!leaderboard_top && !!billboard_top ? (
            top_booking === "billboard_top" ? (
              <BillboardTop {...{ ressort, adbutler_page_id, tags, topic }} />
            ) : (
              <LeaderboardTop {...{ ressort, adbutler_page_id, tags, topic }} />
            )
          ) : !!leaderboard_top && !billboard_top ? (
            <LeaderboardTop {...{ ressort, adbutler_page_id, tags, topic }} />
          ) : (
            <BillboardTop {...{ ressort, adbutler_page_id, tags, topic }} />
          )
        ) : (
          <div style={{ height: 100 }}>
            {/* padding for skyscrapers to work. workaround - needs fixing later! */}
          </div>
        )}
      </div>

      <div style={{ position: "relative" }}>
        {!advertorial.is_advertorial && !is_sensitive ? (
          <div className="is-hidden-touch">
            <Skyscraper
              {...{
                ressort,
                adbutler_page_id,
                tags,
                topic,
                num_placements: skyscraper_right,
              }}
            />
          </div>
        ) : null}

        <div
          className={`columns is-centered-widescreen has-padding-top-10-touch ${
            advertorial.is_advertorial ? "pt-5" : "pt-3"
          }`}
        >
          {/* ARTICLE CONTAINER BEGINS HERE  */}

          <article
            style={{ maxWidth: 1086 }}
            className="column is-7-widescreen is-two-thirds-desktop is-full-touch article-container px-0"
          >
            <ArticleBreadcrumbs {...{ breadcrumb_array }} />
            <div className="px-3">
              <ArticleHeader
                {...{
                  located,
                  display_date,
                  last_update_display,
                  ressort,
                  kicker,
                  headline,
                  teaser,
                  human_authors,
                  is_comment,
                  is_exclusive,
                  advertorial,
                }}
              />
            </div>
            <div className="content mb-0">
              {revised_article_content.map(getContentComponent)}
              {!!gallery_images?.[0] ? (
                <div className="columns is-centered mt-5 mb-6">
                  <div className="column is-9-desktop is-12-mobile">
                    <h2 className="title is-4">{seo_title}: Weitere Bilder</h2>
                    <Gallery {...{ images: gallery_images, defaultImage }} />
                  </div>
                </div>
              ) : null}
              {!human_authors[0] && !!organization_authors[0] ? (
                <div className="columns is-centered">
                  <div className="column is-9-desktop is-12-mobile">
                    <p className="subtitle is-7 has-text-evergabe">
                      Quelle: {organization_authors[0].name}
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
            <div data-nosnippet className="columns is-centered is-mobile mb-6">
              <div className="column is-9-desktop is-12-touch">
                <hr className="has-background-mitternachtsblau-30" />
                <div className="is-flex py-3">
                  <Link
                    to={`/fachzeitschriften/${ressort}`}
                    className="button is-mitternachtsblau is-outlined has-text-weight-bold mr-auto"
                  >
                    Zur Startseite
                  </Link>
                  <ShareArticle
                    {...{
                      path: location.pathname,
                      slugline,
                      seo_title,
                      ressort,
                      topic: topic_data?.slug,
                      description: meta_description,
                    }}
                  />
                </div>
              </div>
            </div>
            {!advertorial.is_advertorial &&
            !is_sensitive &&
            !!advertorialTwo ? (
              <AdvertorialTwo {...{ advertorialTwo }} />
            ) : null}
            {!!job_posting ? <ArticleJobPosting {...{ job_posting }} /> : null}

            {(!self_ads_placed?.related_articles && !!related_articles?.[0]) ||
            (!self_ads_placed?.construction_methods &&
              !!construction_method_blogposts?.[0]) ? (
              <React.Fragment>
                <hr className="mx-3 has-background-mitternachtsblau-30 is-slim" />
                {!self_ads_placed?.related_articles &&
                !!related_articles?.[0] ? (
                  <RelatedArticlesHorizontal
                    {...{
                      related_articles,
                      ressort,
                    }}
                  />
                ) : null}
                {!self_ads_placed?.construction_methods &&
                !!construction_method_blogposts?.[0] ? (
                  <ConstructionMethodsHorizontal
                    {...{
                      construction_method_blogposts,
                    }}
                  />
                ) : null}

                <hr className="mx-3 has-background-mitternachtsblau-30 is-slim" />
              </React.Fragment>
            ) : null}

            <div data-nosnippet className="columns is-centered is-mobile my-6">
              <div className="column is-9-desktop is-12-touch">
                {newestTopicArticles?.nodes?.[0] ? (
                  <div className="pb-4">
                    <p className="title is-4">Neueste Beiträge:</p>
                    {newestTopicArticles?.nodes?.map((article, index) => (
                      <ArticleTeaserCardNewest
                        key={`recommended-article-${index}`}
                        {...{ article, defaultImage, ressort }}
                      />
                    ))}
                  </div>
                ) : null}

                <Link
                  className="link"
                  to={`/fachzeitschriften/${ressort}/${topic_data?.slug}`}
                >
                  Weitere Beiträge
                </Link>
              </div>
            </div>

            {!self_ads_placed?.most_read_articles ? (
              <MostReadArticlesHorizontal
                {...{
                  most_read_articles: mostReadArticles?.nodes,
                  ressort,
                }}
              />
            ) : null}

            {!self_ads_placed.notice_wizard ? (
              <div className="columns is-centered py-5">
                <div className="column is-9">
                  <hr className="is-semi-slim is-mitternachtsblau-10" />
                  <NoticeWizard />
                </div>
              </div>
            ) : null}

            {tags?.[0] ? (
              <RelatedTags {...{ tags, heading: "Verwandte Bau-Themen:" }} />
            ) : null}
            <RelatedTags
              {...{ tags: topFiveTags.nodes, heading: "Top Bau-Themen:" }}
            />

            {ressort === "umweltbau" ? (
              <React.Fragment>
                {umweltbauDates?.nodes?.[0] ? (
                  <LatestBfzEvents {...{ events: umweltbauDates?.nodes }} />
                ) : null}
                {!advertorial.is_advertorial ? (
                  <div className="columns ad-wrapper my-6">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <div className="column " key={`nodig-ad-${index}`}>
                        <NodigAds {...{ place: index, adbutler_page_id }} />
                      </div>
                    ))}
                  </div>
                ) : null}
              </React.Fragment>
            ) : null}
            {/* ##### ARTICLE CONTAINER ENDS HERE ###### */}
          </article>
        </div>
      </div>
      <NewsletterSignup {...{ ressort }} />
    </Layout>
  )
}

export default magazineArticle

export const pageQuery = graphql`
  query (
    $id: String!
    $ressort: String!
    $topic_slug: String!
    $buildDate: Date!
  ) {
    articleData: bfzArticle(id: { eq: $id }) {
      advertorial {
        is_advertorial
        active_from
        active_until
      }
      horizontal_ad_sequence
      vertical_ad_sequence
      place_newsletter_organically
      self_ads_placed {
        newsletter_signup
        construction_methods
        most_read_articles
        related_articles
        notice_wizard
      }
      top_booking
      article_content {
        has_vertical_ad_slot
        has_horizontal_ad_slot
        character_count
        title
        content
        type
        author
        image_number
      }
      article_body
      article_id
      authors {
        strapi_data {
          image {
            localFile {
              childImageSharp {
                thumbnail: gatsbyImageData(
                  formats: [AUTO, AVIF]
                  width: 60
                  layout: FIXED
                  placeholder: BLURRED
                )
              }
            }
          }
          pseudonyms {
            strapi_json_value
          }
          linkedIn
          facebook
          twitter
          xing
          name
        }
        name
        type
      }
      construction_method_blogposts {
        slugline
        title
        teaser
        thumbnail {
          localFile {
            childImageSharp {
              gatsbyImageData(
                formats: [AUTO, AVIF]
                width: 308
                height: 150
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
        }
      }
      topic_data {
        demo_tender_title
        ressort
        short_title
        slug
      }
      article_date
      gt_id
      headline
      is_exclusive
      is_comment
      is_featured
      is_sensitive
      kicker
      last_update
      located
      meta_description
      noindex
      related_articles {
        thumbnail {
          fields {
            focus_point {
              x
              y
            }
          }
          childImageSharp {
            small: gatsbyImageData(
              formats: [AUTO, AVIF]
              width: 307
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        advertorial {
          is_advertorial
        }
        article_date
        headline
        kicker
        is_exclusive
        gt_id
        slugline
        ressort
        topic_data {
          slug
        }
      }
      ressort
      seo_title
      slugline
      teaser
      tags {
        slug
        short_title
      }
      job_posting {
        title
        strapi_id
        has_attention_booster
        customer {
          name
          logo {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  formats: [AUTO, AVIF]
                  width: 114
                  layout: CONSTRAINED
                  placeholder: BLURRED
                )
              }
            }
          }
        }
        location
        teaser
      }
      topic
      article_title_image {
        fields {
          caption
          imageNumber
          zoomable
          focus_point {
            x
            y
          }
        }
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, AVIF]
            width: 1086
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
      article_images {
        fields {
          caption
          imageNumber
          zoomable
          focus_point {
            x
            y
          }
        }
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, AVIF]
            width: 809
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
      article_images_zoomable {
        fields {
          caption
          imageNumber
          focus_point {
            x
            y
          }
        }
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, AVIF]
            quality: 75
            width: 1250
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
      gallery_images {
        fields {
          caption
          imageNumber
        }
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, AVIF]
            quality: 75
            width: 1200
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
      thumbnail_large {
        fields {
          focus_point {
            x
            y
          }
        }
        childImageSharp {
          sd_16x9: gatsbyImageData(
            formats: [AUTO]
            width: 1200
            height: 675
            placeholder: BLURRED
            layout: CONSTRAINED
          )
          sd_4x3: gatsbyImageData(
            formats: [AUTO]
            width: 1200
            height: 900
            placeholder: BLURRED
            layout: CONSTRAINED
          )
          sd_1x1: gatsbyImageData(
            formats: [AUTO]
            width: 1200
            height: 1200
            placeholder: BLURRED
            layout: CONSTRAINED
          )
        }
      }
    }
    advertorialOneData: allBfzArticle(
      sort: { firstcreated: DESC }
      limit: 1
      filter: {
        id: { ne: $id }
        advertorial: {
          active_until: { gte: $buildDate }
          active_from: { lte: $buildDate }
          is_advertorial: { eq: 1 }
        }
        ressort: { eq: $ressort }
      }
    ) {
      nodes {
        gt_id
        advertorial {
          is_advertorial
        }
        thumbnail {
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, AVIF]
              width: 338
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        ressort
        article_date
        headline
        kicker
        slugline
        teaser_short
        tags {
          slug
          short_title
        }
        topic_data {
          slug
        }
      }
    }
    advertorialTwoData: allBfzArticle(
      sort: { firstcreated: DESC }
      limit: 1
      filter: {
        id: { ne: $id }
        advertorial: {
          active_until: { gte: $buildDate }
          active_from: { lte: $buildDate }
          is_advertorial: { eq: 2 }
        }
        ressort: { eq: $ressort }
      }
    ) {
      nodes {
        gt_id
        advertorial {
          is_advertorial
        }
        thumbnail {
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, AVIF]
              width: 338
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        ressort
        article_date
        headline
        kicker
        slugline
        teaser_short
        tags {
          slug
          short_title
        }
        topic_data {
          slug
        }
      }
    }
    advertorialThreeData: allBfzArticle(
      sort: { firstcreated: DESC }
      limit: 1
      filter: {
        id: { ne: $id }
        advertorial: {
          active_until: { gte: $buildDate }
          active_from: { lte: $buildDate }
          is_advertorial: { eq: 3 }
        }
        ressort: { eq: $ressort }
      }
    ) {
      nodes {
        gt_id
        advertorial {
          is_advertorial
        }
        thumbnail {
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, AVIF]
              width: 250
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        ressort
        article_date
        headline
        kicker
        slugline
        teaser_short
        tags {
          slug
          short_title
        }
        topic_data {
          slug
        }
      }
    }
    newestTopicArticles: allBfzArticle(
      filter: {
        ressort: { eq: $ressort }
        topic_data: { slug: { eq: $topic_slug } }
        id: { ne: $id }
      }
      sort: { article_date: DESC }
      limit: 3
    ) {
      nodes {
        advertorial {
          is_advertorial
        }
        ressort
        topic_data {
          slug
        }
        gt_id
        is_exclusive
        is_comment
        slugline
        article_date
        headline
        kicker
        thumbnail {
          fields {
            focus_point {
              x
              y
            }
          }
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, AVIF]
              width: 241
              placeholder: BLURRED
              layout: CONSTRAINED
            )
          }
        }
      }
    }
    topFiveTags: allStrapiBfzTag(
      sort: { total_bfz_article_pageview_count_week: DESC }
      limit: 5
    ) {
      nodes {
        short_title
        slug
        total_bfz_article_pageview_count_week
      }
    }
    umweltbauDates: allStrapiUmweltbauDate(
      sort: { start_time: ASC }
      filter: { dummy: { ne: true } }
      limit: 3
    ) {
      nodes {
        start_time
        end_time
        whole_day
        title
        is_ad
      }
    }
    defaultImage: file(name: { eq: "missing-file" }) {
      childImageSharp {
        gatsbyImageData(
          formats: [AUTO, AVIF]
          width: 690
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    all_active_placements: bfzAdPlacements(ressort: { eq: $ressort }) {
      billboard_top
      halfpage_content
      interscroller
      leaderboard_top
      rectangle
      skyscraper_right
      leaderboard_content
      billboard_content
      outstream_video
    }
    mostReadArticles: allBfzArticle(
      filter: { id: { ne: $id } }
      sort: { page_views_last_sixty_days: DESC }
      limit: 3
    ) {
      nodes {
        gt_id
        ressort
        headline
        kicker
        slugline
        topic_data {
          slug
        }
      }
    }
  }
`
